<!-- Loading Screen -->

@if (!isDataLoaded) {
  <div class="wrapper center"
    >
    <div class="inner-1">
      <mat-spinner> </mat-spinner>
    </div>
  </div>
}

<!-- Records Page -->

@if (isDataLoaded) {
  <div class="container records-page-container"
    >
    <div class="row">
      <div class="col" align="left">
        <h1 i18n class="blue-trip-heading">
        Records
      </h1>
      </div>
      <div class="col" align="right">
        <app-menu> </app-menu>
      </div>
    </div>
    @if (userDetails.currHomepage === 'no-trip-home' && !prevTrips.length) {
      <div class="row"
        >
        <h3 i18n class="blue-subheading">
      You have no trip records.
    </h3>
      </div>
    }
    <!-- Unsubmitted Reports Notification -->
    @if (numUnsubmittedReports) {
      <div class="row button-row"
        >
        <button mat-raised-button
          class="red-button"
          [disabled]="adminUser"
          (click)="attemptSendReports()">
          <mat-icon>
            priority_high
          </mat-icon>
          <span i18n>
        Submit {{numUnsubmittedReports}} outstanding reports.
      </span>
        </button>
      </div>
    }
    <!-- Update Confirmation Numbers Button -->
    <div class="row button-row">
      <button mat-raised-button
        class="red-button"
        (click)="updateConfirmationNumbers()">
        <mat-icon>
          refresh
        </mat-icon>
        <span i18n>
        Update confirmation numbers
      </span>
      </button>
    </div>
    <!-- Current Trip Records -->
    @if (userDetails.currHomepage !== 'no-trip-home') {
      <div>
        <div class="row">
          <h3 i18n class="blue-subheading">
        Current Trip
      </h3>
        </div>
        <!-- Start Report -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title i18n class="panel-title">
          @if (!currTrip.startFishingReport.isSubmitted) {
<mat-icon>
            priority_high
          </mat-icon>
}
          Start Report &nbsp;
          <span class="panel-date" style="font-weight: 500">
            {{sharedMethodsService.getDate(currTrip.startFishingReport.startDate) | date: 'dd/MM/yyyy'}}
          </span>
        </mat-panel-title>
          </mat-expansion-panel-header>
          <h6 i18n class="field-label">
        <span style="display: inline; font-weight: 700;">
          Date Completed:
        </span>
        <span style="display:inline">
          {{sharedMethodsService.getDate(currTrip.startFishingReport.completionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
        </span>
      </h6>
          <h6 i18n class="field-label">
        <span style="display:inline; font-weight:700;">
          Date Submitted:
        </span>
        @if (currTrip.startFishingReport.isSubmitted) {
<span style="display:inline"
             >
          {{sharedMethodsService.getDate(currTrip.startFishingReport.submissionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
        </span>
}
        @if (!currTrip.startFishingReport.isSubmitted) {
<span style="display:inline"
             
              class="not-submitted">
          Not Sent To DFO
        </span>
}
      </h6>
          <h6 i18n class="field-label">
        <span style="display:inline; font-weight:700;">
          Confirmation Number:
        </span>
        <span style="display:inline">
          {{currTrip.startFishingReport.confirmationNumber}}
        </span>
      </h6>
          <h6 i18n class="field-label">
        <span style="display:inline; font-weight:700;">
          Report ID:
        </span>
        <span style="display:inline">
          {{currTrip.startFishingReport.reportID}}
        </span>
      </h6>
          <div class="row" style="padding-top: 15px;"></div>
          <h6 i18n class="field-label">
        <span style="display:inline; font-weight:700;">
          Management Area:
        </span>
        <span style="display:inline">
          {currTrip.startFishingReport.managementArea, select, Area 1 {Area 1} Area 2 {Area 2} Area 3 {Area 3} Area 4 {Area 4} Area 5 {Area 5} Area 6 {Area 6} Area 7 {Area 7} Area 8 {Area 8} Area 9 {Area 9} Area 10 {Area 10} Area 11 {Area 11} Area 12 {Area 12} Area 13 {Area 13} Area 14 {Area 14} Area 15 {Area 15} Area 16 {Area 16} Area 17 {Area 17} Area 18 {Area 18} Area 19 {Area 19} Area 20 {Area 20} Area 21 {Area 21} Area 22 {Area 22} Area 23 {Area 23} Area 24 {Area 24} Area 25 {Area 25} Area 26 {Area 26} Area 27 {Area 27} Area 28 {Area 28} Area 29 {Area 29} Area 101 {Area 101} Area 102 {Area 102} Area 103 {Area 103} Area 104 {Area 104} Area 105 {Area 105} Area 106 {Area 106} Area 107 {Area 107} Area 108 {Area 108} Area 109 {Area 109} Area 110 {Area 110} Area 111 {Area 111} Area 121 {Area 121} Area 123 {Area 123} Area 124 {Area 124} Area 125 {Area 125} Area 126 {Area 126} Area 127 {Area 127} Area 130 {Area 130} Area 142 {Area 142}}
        </span>
      </h6>
          <h6 i18n class="field-label">
        <span style="display:inline; font-weight:700;">
          Start Time:
        </span>
        <span style="display:inline">
          {{sharedMethodsService.getDate(currTrip.startFishingReport.startDate) | date: "shortTime"}}
        </span>
      </h6>
          @if (currTrip.startFishingReport.comments.length) {
            <h6 i18n class="field-label"
              >
        <span style="display:inline; font-weight:700;">
          Comments:
        </span>
        <span style="display:inline">
          {{currTrip.startFishingReport.comments}}
        </span>
      </h6>
          }
        </mat-expansion-panel>
        <!-- Pause Fishing Reports -->
        @if (currTrip.pauseFishingReports.length) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title i18n class="panel-title">
          @if (containsUnsubmittedReports(currTrip.pauseFishingReports)) {
<mat-icon>
            priority_high
          </mat-icon>
}
          Pause Reports &nbsp;
          <span class="panel-date" style="font-weight: 500">
            (count: {{currTrip.pauseFishingReports.length}})
          </span>
        </mat-panel-title>
            </mat-expansion-panel-header>
            @for (pauseReport of currTrip.pauseFishingReports; track pauseReport) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title class="panel-title">
                    @if (!pauseReport.isSubmitted) {
                      <mat-icon>
                        priority_high
                      </mat-icon>
                    }
                    <span class="panel-date">
                      {{sharedMethodsService.getDate(pauseReport.pauseDate) | date: 'dd/MM/yyyy'}}
                    </span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Date Completed:
          </span>
          <span style="display:inline">
            {{sharedMethodsService.getDate(pauseReport.completionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
          </span>
        </h6>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Date Submitted:
          </span>
          @if (pauseReport.isSubmitted) {
<span style="display:inline"
               >
            {{sharedMethodsService.getDate(pauseReport.submissionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
          </span>
}
          @if (!pauseReport.isSubmitted) {
<span style="display:inline"
               
                class="not-submitted">
            Not Sent To DFO
          </span>
}
        </h6>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Confirmation Number:
          </span>
          <span style="display:inline">
            {{pauseReport.confirmationNumber}}
          </span>
        </h6>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Report ID:
          </span>
          <span style="display:inline">
            {{pauseReport.reportID}}
          </span>
        </h6>
                <div class="row" style="padding-top: 15px;"></div>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Management Area:
          </span>
          <span style="display:inline">
            {{pauseReport.managementArea}}
          </span>
        </h6>
                @if (pauseReport.comments.length) {
                  <h6 i18n class="field-label"
                    >
          <span style="display:inline; font-weight:700;">
            Comments:
          </span>
          <span style="display:inline">
            {{pauseReport.comments}}
          </span>
        </h6>
                }
              </mat-expansion-panel>
            }
          </mat-expansion-panel>
        }
        <!-- Daily Catch Reports -->
        @if (currTrip.dailyCatchReports.length) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title i18n class="panel-title">
          @if (containsUnsubmittedReports(currTrip.dailyCatchReports)) {
<mat-icon>
            priority_high
          </mat-icon>
}
          Catch Reports &nbsp;
          <span class="panel-date" style="font-weight: 500">
            (count: {{currTrip.dailyCatchReports.length}})
          </span>
        </mat-panel-title>
            </mat-expansion-panel-header>
            @for (catchReport of currTrip.dailyCatchReports; track catchReport) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title class="panel-title">
                    @if (!catchReport.isSubmitted) {
                      <mat-icon>
                        priority_high
                      </mat-icon>
                    }
                    <span class="panel-date">
                      {{sharedMethodsService.getDate(catchReport.dateFished) | date: 'dd/MM/yyyy'}}
                    </span>
                  </mat-panel-title>
                  @if (catchReport.confirmationNumber.startsWith('FOS')) {
                    <button
                      mat-button
                      color="primary"
          (click)="onEditReport(
            currTrip,
            (currTrip.logbook.gearName === 'Gill Net' ? 'gillnet' :
            currTrip.logbook.gearName === 'Seine'   ? 'seine' :
            'troll'),
            catchReport.internalId
          )">
                      Edit
                    </button>
                  }
                </mat-expansion-panel-header>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Date Completed:
          </span>
          <span style="display:inline">
            {{sharedMethodsService.getDate(catchReport.completionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
          </span>
        </h6>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Date Submitted:
          </span>
          @if (catchReport.isSubmitted) {
<span style="display:inline"
               >
            {{sharedMethodsService.getDate(catchReport.submissionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
          </span>
}
          @if (!catchReport.isSubmitted) {
<span style="display:inline"
               
                class="not-submitted">
            Not Sent To DFO
          </span>
}
        </h6>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Confirmation Number:
          </span>
          <span style="display:inline">
            {{catchReport.confirmationNumber}}
          </span>
        </h6>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Report ID:
          </span>
          <span style="display:inline">
            {{catchReport.reportID}}
          </span>
        </h6>
                <div class="row" style="padding-top: 15px;"></div>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Management Area:
          </span>
          <span style="display:inline">
            {{catchReport.managementArea}}
          </span>
        </h6>
                @if (catchReport.subAreas.length) {
                  <h6 i18n class="field-label"
                    >
          <span style="display:inline; font-weight:700;">
            Subareas or Zones:
          </span>
          @for (subarea of catchReport.subAreas; track subarea; let index = $index) {
<span style="display:inline"
               >
            @if (index < (catchReport.subAreas.length - 1)) {
<span>
              {{subarea}},
            </span>
}
            @if (index === (catchReport.subAreas.length - 1)) {
<span>
              {{subarea}}
            </span>
}
          </span>
}
        </h6>
                }
                @if (currTrip.logbook.gearName==='Gill Net') {
                  <h6 class="field-label"
                    >
                    <span i18n style="display:inline; font-weight:700;">
            Net Used:
          </span>
                    <span i18n style="display:inline">
            {{catchReport.netUsed}} ({catchReport.netUsed.netType, select, Alaska Twist {Alaksa Twist} Multi Strand {Multi Strand} Combination {Combination}})
          </span>
                  </h6>
                }
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Hours Fished:
          </span>
          <span style="display:inline">
            {{catchReport.hoursFished}}
          </span>
        </h6>
                @if (currTrip.logbook.gearName!='Troll') {
                  <h6 i18n class="field-label"
                    >
          <span style="display:inline; font-weight:700;">
            Number of Sets:
          </span>
          <span style="display:inline">
            {{catchReport.numSets}}
          </span>
        </h6>
                }
                @if (currTrip.logbook.gearName==='Troll') {
                  <h6 i18n class="field-label"
                    >
          <span style="display:inline; font-weight:700;">
            Storage Type:
          </span>
          <span style="display:inline">
            {{catchReport.storageType}}
          </span>
        </h6>
                }
                @if (!!catchReport.comments) {
                  <h6 i18n class="field-label"
                    >
          <span style="display:inline; font-weight:700;">
            Comments:
          </span>
          <span style="display:inline">
            {{catchReport.comments}}
          </span>
        </h6>
                }
                <div class="row" style="padding-top: 15px;"></div>
                <!-- Catch Table -->
                @if (catchReport.speciesDataList.length) {
                  <table mat-table
                    [dataSource]="catchReport.speciesDataList"
                    class="mat-elevation-z0 margin-table">
                    <!-- Name Column -->
                    <ng-container matColumnDef="speciesName">
                      <tr>
                        <th i18n mat-header-cell
                          *matHeaderCellDef
                          class="heading-cell">
                Species
              </th>
                        <td mat-cell
                          *matCellDef="let element"
                          class="data-cell">
                          {{element.speciesName}}
                        </td>
                      </tr>
                    </ng-container>
                    <!-- Kept Column -->
                    <ng-container matColumnDef="kept">
                      <tr>
                        <th i18n mat-header-cell
                          *matHeaderCellDef
                          class="heading-cell">
                Kept
              </th>
                        <td mat-cell
                          *matCellDef="let element"
                          class="data-cell">
                          {{element.kept}}
                        </td>
                      </tr>
                    </ng-container>
                    <!-- Released Column -->
                    <ng-container matColumnDef="released">
                      <tr>
                        <th i18n mat-header-cell
                          *matHeaderCellDef
                          class="heading-cell">
                Released
              </th>
                        <td mat-cell
                          *matCellDef="let element"
                          class="data-cell">
                          {{element.released}}
                        </td>
                      </tr>
                    </ng-container>
                    <!-- Rows -->
                    <tr mat-header-row
                      *matHeaderRowDef="catchService.catchColumns">
                    </tr>
                    <tr mat-row
                      *matRowDef="let row; columns: catchService.catchColumns; let index=index;">
                    </tr>
                  </table>
                }
                @if (!catchReport.speciesDataList.length) {
                  <h6 i18n class="field-label"
                    >
          <span style="display:inline; font-weight:700;">
            No Catch Reported.
          </span>
        </h6>
                }
              </mat-expansion-panel>
            }
          </mat-expansion-panel>
        }
        <!-- End Report -->
        @if (currTrip.endFishingReport.isComplete) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title i18n class="panel-title">
              @if (!currTrip.endFishingReport.isSubmitted) {
<mat-icon>
                priority_high
              </mat-icon>
}
              End Report &nbsp;
              <span class="panel-date" style="font-weight: 500">
                {{sharedMethodsService.getDate(currTrip.endFishingReport.endDate) | date: 'dd/MM/yyyy'}}
              </span>
            </mat-panel-title>
              @if (currTrip.endFishingReport.confirmationNumber.startsWith('FOS')) {
                <button
                  mat-button
                  color="primary"
                  (click)="onEditReport(currTrip, 'end', currTrip.endFishingReport.internalId)">
                  Edit
                </button>
              }
            </mat-expansion-panel-header>
            <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Date Completed:
            </span>
            <span style="display:inline">
              {{sharedMethodsService.getDate(currTrip.endFishingReport.completionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
            </span>
          </h6>
            <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Date Submitted:
            </span>
            @if (currTrip.endFishingReport.isSubmitted) {
<span style="display:inline"
                 >
              {{sharedMethodsService.getDate(currTrip.endFishingReport.submissionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
            </span>
}
            @if (!currTrip.endFishingReport.isSubmitted) {
<span style="display:inline"
                 
                  class="not-submitted">
              Not Sent To DFO
            </span>
}
          </h6>
            <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Confirmation Number:
            </span>
            <span style="display:inline">
              {{currTrip.endFishingReport.confirmationNumber}}
            </span>
          </h6>
            <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Report ID:
            </span>
            <span style="display:inline">
              {{currTrip.endFishingReport.reportID}}
            </span>
          </h6>
            <div class="row" style="padding-top: 15px;"></div>
            @if (currTrip.endFishingReport.comments.length) {
              <h6 i18n class="field-label"
                >
            <span style="display:inline; font-weight:700;">
              Comments:
            </span>
            <span style="display:inline">
              {{currTrip.endFishingReport.comments}}
            </span>
          </h6>
            }
            @if (currTrip.licenseArea.licenseName === 'G') {
              <div>
                <h6 i18n class="field-label">
              <span style="display:inline; font-weight:700;">
                Landing Site:
              </span>
              <span style="display:inline">
                {{currTrip.endFishingReport.landingSite}}
              </span>
            </h6>
                <h6 i18n class="field-label">
              <span style="display:inline; font-weight:700;">
                Planned Offload Date:
              </span>
              <span style="display:inline">
                {{sharedMethodsService.getDate(currTrip.endFishingReport.plannedOffloadDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
              </span>
            </h6>
              </div>
            }
          </mat-expansion-panel>
        }
        <!-- Offload Catch Reports -->
        @if (currTrip.offloadReports.length) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title i18n class="panel-title">
          @if (containsUnsubmittedReports(currTrip.offloadReports)) {
<mat-icon>
            priority_high
          </mat-icon>
}
          Offload Reports &nbsp;
          <span class="panel-date" style="font-weight: 500">
            (count: {{currTrip.offloadReports.length}})
          </span>
        </mat-panel-title>
            </mat-expansion-panel-header>
            @for (offloadReport of currTrip.offloadReports; track offloadReport) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title class="panel-title">
                    @if (!offloadReport.isSubmitted) {
                      <mat-icon>
                        priority_high
                      </mat-icon>
                    }
                    <span class="panel-date">
                      {{sharedMethodsService.getDate(offloadReport.offloadDate) | date: 'dd/MM/yyyy'}}
                    </span>
                  </mat-panel-title>
                  @if (offloadReport.confirmationNumber.startsWith('FOS')) {
                    <button
                      mat-button
                      color="primary"
                      (click)="onEditReport(currTrip, 'offload', offloadReport.internalId)">
                      Edit
                    </button>
                  }
                </mat-expansion-panel-header>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Date Completed:
          </span>
          <span style="display:inline">
            {{sharedMethodsService.getDate(offloadReport.completionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
          </span>
        </h6>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Date Submitted:
          </span>
          @if (offloadReport.isSubmitted) {
<span style="display:inline"
               >
            {{sharedMethodsService.getDate(offloadReport.submissionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
          </span>
}
          @if (!offloadReport.isSubmitted) {
<span style="display:inline"
               
                class="not-submitted">
            Not Sent To DFO
          </span>
}
        </h6>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Confirmation Number:
          </span>
          <span style="display:inline">
            {{offloadReport.confirmationNumber}}
          </span>
        </h6>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Report ID:
          </span>
          <span style="display:inline">
            {{offloadReport.reportID}}
          </span>
        </h6>
                <div class="row" style="padding-top: 15px;"></div>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Offload Time:
          </span>
          <span style="display:inline">
            {{sharedMethodsService.getDate(offloadReport.offloadDate) | date: "shortTime"}}
          </span>
        </h6>
                <h6 class="field-label">
                  <span i18n style="display:inline; font-weight:700;">
            Landing Site:
          </span>
                  @if (offloadReport.landingSite.name == 'Not Listed' || offloadReport.landingSite.name == 'Not Offloading / No Catch') {
                    <span>
                      {offloadReport.landingSite, select, Not Listed {Not Listed} Not Offloading / No Catch {Not Offloading / No Catch}}
                    </span>
                  }
                  @if (offloadReport.landingSite.name != 'Not Listed' && offloadReport.landingSite.name != 'Not Offloading / No Catch') {
                    <span>
                      {{offloadReport.landingSite}}
                    </span>
                  }
                </h6>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Product Type:
          </span>
          <span style="display:inline">
            {offloadReport.productType, select, Unknown {Unknown} Round, Fresh {Round, Fresh} Dressed, Head On, Fresh {Dressed, Head On, Fresh} Dressed, Head Off, Fresh {Dressed, Head Off, Fresh} Round, Frozen {Round, Frozen} Dressed, Head On, Frozen {Dressed, Head On, Frozen} Dressed, Head Off, Frozen {Dressed, Head Off, Frozen} Roe, Fresh {Roe, Fresh} Round, Unknown Preservation {Round, Unknown Preservation}}
          </span>
        </h6>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Last Management Area Fished:
          </span>
          <span style="display:inline">
            {offloadReport.lastMgmtArea, select, Area 1 {Area 1} Area 2 {Area 2} Area 3 {Area 3} Area 4 {Area 4} Area 5 {Area 5} Area 6 {Area 6} Area 7 {Area 7} Area 8 {Area 8} Area 9 {Area 9} Area 10 {Area 10} Area 11 {Area 11} Area 12 {Area 12} Area 13 {Area 13} Area 14 {Area 14} Area 15 {Area 15} Area 16 {Area 16} Area 17 {Area 17} Area 18 {Area 18} Area 19 {Area 19} Area 20 {Area 20} Area 21 {Area 21} Area 22 {Area 22} Area 23 {Area 23} Area 24 {Area 24} Area 25 {Area 25} Area 26 {Area 26} Area 27 {Area 27} Area 28 {Area 28} Area 29 {Area 29} Area 101 {Area 101} Area 102 {Area 102} Area 103 {Area 103} Area 104 {Area 104} Area 105 {Area 105} Area 106 {Area 106} Area 107 {Area 107} Area 108 {Area 108} Area 109 {Area 109} Area 110 {Area 110} Area 111 {Area 111} Area 121 {Area 121} Area 123 {Area 123} Area 124 {Area 124} Area 125 {Area 125} Area 126 {Area 126} Area 127 {Area 127} Area 130 {Area 130} Area 142 {Area 142}}
          </span>
        </h6>
                @if (offloadReport.lastSubarea.isValid()) {
                  <h6 i18n class="field-label"
                    >
          <span style="display:inline; font-weight:700;">
            Last Subarea Fished:
          </span>
          <span style="display:inline">
            {{offloadReport.lastSubarea}}
          </span>
        </h6>
                }
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Number of Days Fished:
          </span>
          <span style="display:inline">
            {{offloadReport.numDaysFished}}
          </span>
        </h6>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            First and Last Days Fished:
          </span>
          <span style="display:inline">
            {{offloadReport.firstDateFished |  date: 'dd/MM/yyyy'}} -  {{offloadReport.lastDateFished |  date: 'dd/MM/yyyy'}}
          </span>
        </h6>
                <h6 i18n class="field-label">
          <span style="display:inline; font-weight:700;">
            Fish Slip Issued:
          </span>
          <span style="display:inline">
            {offloadReport.fishSlip, select, Yes {Yes} No {No}}
          </span>
        </h6>
                @if (offloadReport.fishSlip==='Yes') {
                  <h6 i18n class="field-label"
                    >
          <span style="display:inline; font-weight:700;">
            Fish Slip Number:
          </span>
          <span style="display:inline">
            {{offloadReport.fishSlipNumber}}
          </span>
        </h6>
                }
                @if (offloadReport.comments.length) {
                  <h6 i18n class="field-label"
                    >
          <span style="display:inline; font-weight:700;">
            Comments:
          </span>
          <span style="display:inline">
            {{offloadReport.comments}}
          </span>
        </h6>
                }
                <div class="row" style="padding-top: 15px;"></div>
                <!-- Offload Catch Table -->
                @if (offloadReport.speciesDataList.length) {
                  <table mat-table
                    [dataSource]="offloadReport.speciesDataList"
                    class="mat-elevation-z0 margin-table">
                    <!-- Name Column -->
                    <ng-container matColumnDef="speciesName">
                      <tr>
                        <th i18n mat-header-cell
                          *matHeaderCellDef
                          class="heading-cell">
                Species
              </th>
                        <td mat-cell class="data-cell"
                          *matCellDef="let element">
                          {{element.speciesName}}
                        </td>
                      </tr>
                    </ng-container>
                    <!-- Weight Column (Seine only) -->
                    @if (currTrip.logbook.gearName === 'Seine') {
                      <ng-container
                        matColumnDef="weight">
                        <tr>
                          <th i18n mat-header-cell
                            *matHeaderCellDef
                            class="heading-cell">
                Weight <small>({{offloadReport.catchWeightUnits}})</small>
              </th>
                          <td mat-cell class="data-cell"
                            *matCellDef="let element">
                            {{element.offloadWeight}}
                          </td>
                        </tr>
                      </ng-container>
                    }
                    <!-- Pieces Column -->
                    <ng-container matColumnDef="pieces">
                      <tr>
                        <th i18n mat-header-cell
                          *matHeaderCellDef
                          class="heading-cell">
                Pieces
              </th>
                        <td mat-cell class="data-cell"
                          *matCellDef="let element">
                          {{element.offloadPieces}}
                        </td>
                      </tr>
                    </ng-container>
                    <!-- Rows -->
                    <tr mat-header-row
                      *matHeaderRowDef="determineOffloadColumns(currTrip.logbook.gearName)">
                    </tr>
                    <tr mat-row
                      *matRowDef="let row; columns: determineOffloadColumns(currTrip.logbook.gearName); let index=index;">
                    </tr>
                  </table>
                }
                @if (!offloadReport.speciesDataList.length) {
                  <h6 i18n class="field-label"
                    >
          <span style="display:inline; font-weight:700;">
            No Catch Reported.
          </span>
        </h6>
                }
              </mat-expansion-panel>
            }
          </mat-expansion-panel>
        }
      </div>
    }
    <!-- Past Trip Records -->
    @if (prevTrips.length) {
      <div class="row"
        >
        <div class="col" align="left">
          <h3 i18n class="blue-subheading">
        Past Trips
      </h3>
        </div>
        <!-- Filter Tool -->
        <div class="col" align="right">
          <button mat-button
            type="button"
            class="filter-tool"
            [matMenuTriggerFor]="filterMenu">
            <mat-icon class="filter-button">
              filter_list
            </mat-icon>
            <span i18n class="panel-date" style="margin-top: 10px;">
          Filter Trips
        </span>
          </button>
        </div>
        <mat-menu #filterMenu="matMenu" class="filter-menu">
          <button mat-menu-item [matMenuTriggerFor]="logbookMenu">
            <span i18n class="filter-menu-item"> Logbooks ({{selectedLogbookCount}}) </span>
          </button>
          <button mat-menu-item [matMenuTriggerFor]="licenseAreaMenu">
            <span i18n class="filter-menu-item"> License Areas ({{selectedLicenseAreaCount}}) </span>
          </button>
          <button mat-menu-item [matMenuTriggerFor]="vesselMenu">
            <span i18n class="filter-menu-item"> Vessels ({{selectedVesselCount}}) </span>
          </button>
          <button mat-menu-item [matMenuTriggerFor]="dateSelect">
            <span i18n class="filter-menu-item"> Date Range </span>
          </button>
        </mat-menu>
        <mat-menu #logbookMenu="matMenu" class="filter-menu">
          @for (logbook of logbooks; track logbook) {
            <button mat-menu-item (click)="selectItem($event, logbook)">
              <mat-icon color="{{logbook.isChecked ? 'primary' : ''}}"
                class="checkbox-icon">
                {{logbook.isChecked ? 'check_box' : 'check_box_outline_blank'}}
              </mat-icon>
              <span i18n class="filter-menu-item">
          {logbook.gearName, select, Gill Net {Gillnet} Seine {Seine} Troll {Troll}} (#{{logbook.logbookID}})
        </span>
            </button>
          }
        </mat-menu>
        <mat-menu #licenseAreaMenu="matMenu" class="filter-menu">
          @for (area of licenseAreas; track area) {
            <button mat-menu-item (click)="selectItem($event, area)">
              <mat-icon color="{{area.isChecked ? 'primary' : ''}}"
                class="checkbox-icon">
                {{area.isChecked ? 'check_box' : 'check_box_outline_blank'}}
              </mat-icon>
              <span i18n class="filter-menu-item">
          {area, select, A (Seine North) {A (Seine North)} B (Seine South) {B (Seine South)} C (Gillnet North) {C (Gillnet North)} D (Gillnet Vancouver Island) {D (Gillnet Vancouver Island)} E (Gillnet Fraser + VI) {E (Gillnet Fraser + VI)} F (Troll North) {F (Troll North)} G (Troll WCVI) {G (Troll WCVI)} H (Troll Fraser) {H (Troll Fraser)}}
        </span>
            </button>
          }
        </mat-menu>
        <mat-menu #vesselMenu="matMenu" class="filter-menu">
          @for (vessel of vessels; track vessel) {
            <button mat-menu-item (click)="selectItem($event, vessel)">
              <mat-icon color="{{vessel.isChecked ? 'primary' : ''}}"
                class="checkbox-icon">
                {{vessel.isChecked ? 'check_box' : 'check_box_outline_blank'}}
              </mat-icon>
              <span class="filter-menu-item">
                {{vessel}}
              </span>
            </button>
          }
        </mat-menu>
        <mat-menu #dateSelect="matMenu" class="filter-menu">
          <form [formGroup]="tripDateForm">
            <mat-form-field appearance="fill">
              <mat-label i18n>
            MM/DD/YYYY - MM/DD/YYYY
          </mat-label>
              <mat-date-range-input [rangePicker]="rangePicker" (click)="$event.stopPropagation();">
                <input matStartDate
                  formControlName="startDate"
                  placeholder="Start date"
                  i18n-placeholder="Start date placeholder" />
                  <input matEndDate
                    formControlName="endDate"
                    placeholder="End date"
                    i18n-placeholder="End date placeholder" />
                  </mat-date-range-input>
                  <mat-hint i18n class="checkbox-icon">
            Find All Trips Within These Dates
          </mat-hint>
                  <mat-datepicker-toggle matIconSuffix
                  [for]="rangePicker"></mat-datepicker-toggle>
                  <mat-date-range-picker touchUi #rangePicker></mat-date-range-picker>
                </mat-form-field>
              </form>
            </mat-menu>
          </div>
        }
        @if (filtersApplied()) {
          <div class="row">
            <div class="outer">
              <div class="inner">
                @if (selectedLogbookCount>0) {
                  <button i18n mat-flat-button
                    class="filter-item-button"
                    (click)="clearLogbookFilter()">
          Logbooks: {{selectedLogbookCount}}
          <mat-icon>close</mat-icon>
        </button>
                }
              </div>
              <div class="inner">
                @if (selectedLicenseAreaCount>0) {
                  <button i18n mat-flat-button
                    class="filter-item-button"
                    (click)="clearAreaFilter()">
          License Areas: {{selectedLicenseAreaCount}}
          <mat-icon>close</mat-icon>
        </button>
                }
              </div>
              <div class="inner">
                @if (selectedVesselCount>0) {
                  <button i18n mat-flat-button
                    class="filter-item-button"
                    (click)="clearVesselFilter()">
          Vessels: {{selectedVesselCount}}
          <mat-icon>close</mat-icon>
        </button>
                }
              </div>
              <div class="inner">
                @if (isFilled()) {
                  <button i18n mat-flat-button
                    class="filter-item-button"
                    (click)="clearForm()">
          Date Range: {{selectedDateRange}}
          <mat-icon>close</mat-icon>
        </button>
                }
              </div>
            </div>
          </div>
        }
        @for (trip of prevTrips; track trip) {
          <div>
            @if (determineTripVisibility(trip)) {
              <mat-expansion-panel
                class="past-trips">
                <!-- Trip Panel -->
                <mat-expansion-panel-header>
                  <mat-panel-title i18n class="panel-title"
                    style="font-size:18px">
          @if (trip.unsubmittedReports.length) {
<mat-icon>
            priority_high
          </mat-icon>
}
          Trip&nbsp;&nbsp;&nbsp;
          <span class="panel-date"
                style="font-size: 16px; font-weight: 500;">
            {{sharedMethodsService.getDate(trip.startFishingReport.startDate) | date: 'dd/MM/yyyy'}}&nbsp;
          </span>
          @if (trip.endFishingReport.isComplete && !trip.cancelFishingReport.isComplete) {
<span span style="display: inline;
                                  font-size: 16px;
                                  font-weight: 500;"
                class="panel-date"
               >
            - {{sharedMethodsService.getDate(trip.endFishingReport.endDate) | date: 'dd/MM/yyyy'}}
          </span>
}
          @if (trip.cancelFishingReport.isComplete && !trip.endFishingReport.isComplete) {
<span span style="display: inline;
                                  font-size: 16px;
                                  font-weight: 500;"
                class="panel-date"
               >
            - {{sharedMethodsService.getDate(trip.startFishingReport.startDate)| date: 'dd/MM/yyyy'}}
          </span>
}
        </mat-panel-title>
                </mat-expansion-panel-header>
                <!-- General Trip Information -->
                <div class="trip-info" align="center">
                  <h6 i18n class="descriptive-text">
          Logbook:
          <span style="display: inline; font-weight: 400; color: #005d87;">
            {trip.logbook.gearName, select, Gill Net {Gillnet} Seine {Seine} Troll {Troll}} (#{{trip.logbook.logbookID}})
          </span>
        </h6>
                </div>
                <div class="trip-info" align="center">
                  <h6 i18n class="descriptive-text">
          Vessel:
          <span style="display:inline; font-weight:400; color:#005d87;">
            {{trip.vessel}}
          </span>
        </h6>
                </div>
                <div class="trip-info" align="center">
                  <h6 i18n class="descriptive-text">
          License Area:
          <span style="display:inline; font-weight:400; color:#005d87;">
            {trip.licenseArea, select, A (Seine North) {A (Seine North)} B (Seine South) {B (Seine South)} C (Gillnet North) {C (Gillnet North)} D (Gillnet Vancouver Island) {D (Gillnet Vancouver Island)} E (Gillnet Fraser + VI) {E (Gillnet Fraser + VI)} F (Troll North) {F (Troll North)} G (Troll WCVI) {G (Troll WCVI)} H (Troll Fraser) {H (Troll Fraser)}}
          </span>
        </h6>
                </div>
                <!-- Resume Trip -->
                @if (!adminUser) {
                  <div class="row button-row">
                    <button mat-raised-button
                      class="red-button"
                      [disabled]="!canResumeTrip(trip)"
                      (click)="onResumeTrip(trip)">
                      <mat-icon>
                        restore
                      </mat-icon>
                      <span i18n>
                        Make this my current trip
                      </span>
                    </button>
                  </div>
                  @if (!canResumeTrip(trip)) {
                    <div class="trip-info" align="center">
                      <h6 i18n class="descriptive-text" style="font-weight: 400;">
                        This trip cannot be resumed because its logbook is no longer active.
                      </h6>
                    </div>
                  }
                }
                <div style="margin-bottom: 25px;"></div>
                <!-- Start Report -->
                <div class="sub-trips">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title i18n class="panel-title">
              @if (!trip.startFishingReport.isSubmitted) {
<mat-icon>
                priority_high
              </mat-icon>
}
              Start Report &nbsp;
              <span class="panel-date" style="font-weight: 500">
                {{sharedMethodsService.getDate(trip.startFishingReport.startDate) | date: 'dd/MM/yyyy'}}
              </span>
            </mat-panel-title>
                    </mat-expansion-panel-header>
                    <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Date Completed:
            </span>
            <span style="display:inline">
              {{sharedMethodsService.getDate(trip.startFishingReport.completionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
            </span>
          </h6>
                    <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Date Submitted:
            </span>
            @if (trip.startFishingReport.isSubmitted) {
<span style="display:inline"
                 >
              {{sharedMethodsService.getDate(trip.startFishingReport.submissionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
            </span>
}
            @if (!trip.startFishingReport.isSubmitted) {
<span style="display:inline"
                 
                  class="not-submitted">
              Not Sent To DFO
            </span>
}
          </h6>
                    <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Confirmation Number:
            </span>
            <span style="display:inline">
              {{trip.startFishingReport.confirmationNumber}}
            </span>
          </h6>
                    <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Report ID:
            </span>
            <span style="display:inline">
              {{trip.startFishingReport.reportID}}
            </span>
          </h6>
                    <div class="row" style="padding-top: 15px;"></div>
                    <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Management Area:
            </span>
            <span style="display:inline">
              {trip.startFishingReport.managementArea, select, Area 1 {Area 1} Area 2 {Area 2} Area 3 {Area 3} Area 4 {Area 4} Area 5 {Area 5} Area 6 {Area 6} Area 7 {Area 7} Area 8 {Area 8} Area 9 {Area 9} Area 10 {Area 10} Area 11 {Area 11} Area 12 {Area 12} Area 13 {Area 13} Area 14 {Area 14} Area 15 {Area 15} Area 16 {Area 16} Area 17 {Area 17} Area 18 {Area 18} Area 19 {Area 19} Area 20 {Area 20} Area 21 {Area 21} Area 22 {Area 22} Area 23 {Area 23} Area 24 {Area 24} Area 25 {Area 25} Area 26 {Area 26} Area 27 {Area 27} Area 28 {Area 28} Area 29 {Area 29} Area 101 {Area 101} Area 102 {Area 102} Area 103 {Area 103} Area 104 {Area 104} Area 105 {Area 105} Area 106 {Area 106} Area 107 {Area 107} Area 108 {Area 108} Area 109 {Area 109} Area 110 {Area 110} Area 111 {Area 111} Area 121 {Area 121} Area 123 {Area 123} Area 124 {Area 124} Area 125 {Area 125} Area 126 {Area 126} Area 127 {Area 127} Area 130 {Area 130} Area 142 {Area 142}}
            </span>
          </h6>
                    <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Start Time:
            </span>
            <span style="display:inline">
              {{sharedMethodsService.getDate(trip.startFishingReport.startDate) | date: "shortTime"}}
            </span>
          </h6>
                    @if (trip.startFishingReport.comments.length) {
                      <h6 i18n class="field-label"
                        >
            <span style="display:inline; font-weight:700;">
              Comments:
            </span>
            <span style="display:inline">
              {{trip.startFishingReport.comments}}
            </span>
          </h6>
                    }
                  </mat-expansion-panel>
                </div>
                <!-- End Report -->
                <div class="sub-trips">
                  @if (trip.endFishingReport.isComplete) {
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title i18n class="panel-title">
              @if (!trip.endFishingReport.isSubmitted) {
<mat-icon>
                priority_high
              </mat-icon>
}
              End Report &nbsp;
              <span class="panel-date" style="font-weight: 500">
                {{sharedMethodsService.getDate(trip.endFishingReport.endDate) | date: 'dd/MM/yyyy'}}
              </span>
            </mat-panel-title>
                        @if (trip.endFishingReport.confirmationNumber.startsWith('FOS')) {
                          <button
                            mat-button
                            color="primary"
                            (click)="onEditReport(trip, 'end', trip.endFishingReport.internalId)">
                            Edit
                          </button>
                        }
                      </mat-expansion-panel-header>
                      <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Date Completed:
            </span>
            <span style="display:inline">
              {{sharedMethodsService.getDate(trip.endFishingReport.completionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
            </span>
          </h6>
                      <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Date Submitted:
            </span>
            @if (trip.endFishingReport.isSubmitted) {
<span style="display:inline"
                 >
              {{sharedMethodsService.getDate(trip.endFishingReport.submissionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
            </span>
}
            @if (!trip.endFishingReport.isSubmitted) {
<span style="display:inline"
                 
                  class="not-submitted">
              Not Sent To DFO
            </span>
}
          </h6>
                      <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Confirmation Number:
            </span>
            <span style="display:inline">
              {{trip.endFishingReport.confirmationNumber}}
            </span>
          </h6>
                      <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Report ID:
            </span>
            <span style="display:inline">
              {{trip.endFishingReport.reportID}}
            </span>
          </h6>
                      <div class="row" style="padding-top: 15px;"></div>
                      @if (trip.endFishingReport.comments.length) {
                        <h6 i18n class="field-label"
                          >
            <span style="display:inline; font-weight:700;">
              Comments:
            </span>
            <span style="display:inline">
              {{trip.endFishingReport.comments}}
            </span>
          </h6>
                      }
                      @if (trip.licenseArea.licenseName === 'G') {
                        <div>
                          <h6 i18n class="field-label">
              <span style="display:inline; font-weight:700;">
                Landing Site:
              </span>
              <span style="display:inline">
                {{trip.endFishingReport.landingSite}}
              </span>
            </h6>
                          <h6 i18n class="field-label">
              <span style="display:inline; font-weight:700;">
                Planned Offload Date:
              </span>
              <span style="display:inline">
                {{sharedMethodsService.getDate(trip.endFishingReport.plannedOffloadDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
              </span>
            </h6>
                        </div>
                      }
                    </mat-expansion-panel>
                  }
                </div>
                <!-- Cancel Report -->
                <div class="sub-trips">
                  @if (trip.cancelFishingReport.isComplete) {
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title i18n class="panel-title">
              @if (!trip.cancelFishingReport.isSubmitted) {
<mat-icon>
                priority_high
              </mat-icon>
}
              Cancel Report &nbsp;
              <span class="panel-date" style="font-weight: 500">
                {{sharedMethodsService.getDate(trip.startFishingReport.startDate) | date: 'dd/MM/yyyy'}}
              </span>
            </mat-panel-title>
                      </mat-expansion-panel-header>
                      <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Date Completed:
            </span>
            <span style="display:inline">
              {{sharedMethodsService.getDate(trip.cancelFishingReport.completionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
            </span>
          </h6>
                      <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Date Submitted:
            </span>
            @if (trip.cancelFishingReport.isSubmitted) {
<span style="display:inline"
                 >
              {{sharedMethodsService.getDate(trip.cancelFishingReport.submissionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
            </span>
}
            @if (!trip.cancelFishingReport.isSubmitted) {
<span style="display:inline"
                 
                  class="not-submitted">
              Not Sent To DFO
            </span>
}
          </h6>
                      <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Confirmation Number:
            </span>
            <span style="display:inline">
              {{trip.cancelFishingReport.confirmationNumber}}
            </span>
          </h6>
                      <h6 i18n class="field-label">
            <span style="display:inline; font-weight:700;">
              Report ID:
            </span>
            <span style="display:inline">
              {{trip.cancelFishingReport.reportID}}
            </span>
          </h6>
                      <div class="row" style="padding-top: 15px;"></div>
                      @if (trip.cancelFishingReport.comments.length) {
                        <h6 i18n class="field-label"
                          >
            <span style="display:inline; font-weight:700;">
              Comments:
            </span>
            <span style="display:inline">
              {{trip.cancelFishingReport.comments}}
            </span>
          </h6>
                      }
                    </mat-expansion-panel>
                  }
                </div>
                <!-- Pause Fishing Reports -->
                <div class="sub-trips">
                  @if (trip.pauseFishingReports.length) {
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title i18n class="panel-title">
              @if (containsUnsubmittedReports(trip.pauseFishingReports)) {
<mat-icon>
                priority_high
              </mat-icon>
}
              Pause Reports &nbsp;
              <span class="panel-date" style="font-weight: 500">
                (count: {{trip.pauseFishingReports.length}})
              </span>
            </mat-panel-title>
                      </mat-expansion-panel-header>
                      @for (pauseReport of trip.pauseFishingReports; track pauseReport) {
                        <div class="sub-trips"
                          >
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>
                              <mat-panel-title class="panel-title">
                                @if (!pauseReport.isSubmitted) {
                                  <mat-icon>
                                    priority_high
                                  </mat-icon>
                                }
                                <span class="panel-date">
                                  {{sharedMethodsService.getDate(pauseReport.pauseDate) | date: 'dd/MM/yyyy'}}
                                </span>
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Date Completed:
                </span>
                <span style="display:inline">
                  {{sharedMethodsService.getDate(pauseReport.completionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
                </span>
              </h6>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Date Submitted:
                </span>
                @if (pauseReport.isSubmitted) {
<span style="display:inline"
                     >
                  {{sharedMethodsService.getDate(pauseReport.submissionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
                </span>
}
                @if (!pauseReport.isSubmitted) {
<span style="display:inline"
                     
                      class="not-submitted">
                  Not Sent To DFO
                </span>
}
              </h6>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Confirmation Number:
                </span>
                <span style="display:inline">
                  {{pauseReport.confirmationNumber}}
                </span>
              </h6>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Report ID:
                </span>
                <span style="display:inline">
                  {{pauseReport.reportID}}
                </span>
              </h6>
                            <div class="row" style="padding-top: 15px;"></div>
                            <h6 class="field-label">
                              <span i18n style="display:inline; font-weight:700;">
                  Management Area:
                </span>
                              <span i18n style="display:inline">
                  {pauseReport.managementArea, select, Area 1 {Area 1} Area 2 {Area 2} Area 3 {Area 3} Area 4 {Area 4} Area 5 {Area 5} Area 6 {Area 6} Area 7 {Area 7} Area 8 {Area 8} Area 9 {Area 9} Area 10 {Area 10} Area 11 {Area 11} Area 12 {Area 12} Area 13 {Area 13} Area 14 {Area 14} Area 15 {Area 15} Area 16 {Area 16} Area 17 {Area 17} Area 18 {Area 18} Area 19 {Area 19} Area 20 {Area 20} Area 21 {Area 21} Area 22 {Area 22} Area 23 {Area 23} Area 24 {Area 24} Area 25 {Area 25} Area 26 {Area 26} Area 27 {Area 27} Area 28 {Area 28} Area 29 {Area 29} Area 101 {Area 101} Area 102 {Area 102} Area 103 {Area 103} Area 104 {Area 104} Area 105 {Area 105} Area 106 {Area 106} Area 107 {Area 107} Area 108 {Area 108} Area 109 {Area 109} Area 110 {Area 110} Area 111 {Area 111} Area 121 {Area 121} Area 123 {Area 123} Area 124 {Area 124} Area 125 {Area 125} Area 126 {Area 126} Area 127 {Area 127} Area 130 {Area 130} Area 142 {Area 142}}
                </span>
                            </h6>
                            @if (pauseReport.comments.length) {
                              <h6 i18n class="field-label"
                                >
                <span style="display:inline; font-weight:700;">
                  Comments:
                </span>
                <span style="display:inline">
                  {{pauseReport.comments}}
                </span>
              </h6>
                            }
                          </mat-expansion-panel>
                        </div>
                      }
                    </mat-expansion-panel>
                  }
                </div>
                <!-- Daily Catch Reports -->
                <div class="sub-trips">
                  @if (trip.dailyCatchReports.length) {
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title i18n class="panel-title">
              @if (containsUnsubmittedReports(trip.dailyCatchReports)) {
<mat-icon>
                priority_high
              </mat-icon>
}
              Catch Reports &nbsp;
              <span class="panel-date" style="font-weight: 500">
                (count: {{trip.dailyCatchReports.length}})
              </span>
            </mat-panel-title>
                      </mat-expansion-panel-header>
                      @for (catchReport of trip.dailyCatchReports; track catchReport) {
                        <div class="sub-trips"
                          >
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>
                              <mat-panel-title class="panel-title">
                                @if (!catchReport.isSubmitted) {
                                  <mat-icon>
                                    priority_high
                                  </mat-icon>
                                }
                                <span class="panel-date">
                                  {{sharedMethodsService.getDate(catchReport.dateFished) | date: 'dd/MM/yyyy'}}
                                </span>
                              </mat-panel-title>
                              @if (catchReport.confirmationNumber.startsWith('FOS')) {
                                <button
                                  mat-button
                                  color="primary"
                  (click)="onEditReport(
                    trip,
                    (trip.logbook.gearName === 'Gill Net' ? 'gillnet' :
                    trip.logbook.gearName === 'Seine'   ? 'seine' :
                    'troll'),
                    catchReport.internalId
                  )">
                                  Edit
                                </button>
                              }
                            </mat-expansion-panel-header>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Date Completed:
                </span>
                <span style="display:inline">
                  {{sharedMethodsService.getDate(catchReport.completionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
                </span>
              </h6>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Date Submitted:
                </span>
                @if (catchReport.isSubmitted) {
<span style="display:inline"
                     >
                  {{sharedMethodsService.getDate(catchReport.submissionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
                </span>
}
                @if (!catchReport.isSubmitted) {
<span style="display:inline"
                     
                      class="not-submitted">
                  Not Sent To DFO
                </span>
}
              </h6>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Confirmation Number:
                </span>
                <span style="display:inline">
                  {{catchReport.confirmationNumber}}
                </span>
              </h6>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Report ID:
                </span>
                <span style="display:inline">
                  {{catchReport.reportID}}
                </span>
              </h6>
                            <div class="row" style="padding-top: 15px;"></div>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Management Area:
                </span>
                <span style="display:inline">
                  {catchReport.managementArea, select, Area 1 {Area 1} Area 2 {Area 2} Area 3 {Area 3} Area 4 {Area 4} Area 5 {Area 5} Area 6 {Area 6} Area 7 {Area 7} Area 8 {Area 8} Area 9 {Area 9} Area 10 {Area 10} Area 11 {Area 11} Area 12 {Area 12} Area 13 {Area 13} Area 14 {Area 14} Area 15 {Area 15} Area 16 {Area 16} Area 17 {Area 17} Area 18 {Area 18} Area 19 {Area 19} Area 20 {Area 20} Area 21 {Area 21} Area 22 {Area 22} Area 23 {Area 23} Area 24 {Area 24} Area 25 {Area 25} Area 26 {Area 26} Area 27 {Area 27} Area 28 {Area 28} Area 29 {Area 29} Area 101 {Area 101} Area 102 {Area 102} Area 103 {Area 103} Area 104 {Area 104} Area 105 {Area 105} Area 106 {Area 106} Area 107 {Area 107} Area 108 {Area 108} Area 109 {Area 109} Area 110 {Area 110} Area 111 {Area 111} Area 121 {Area 121} Area 123 {Area 123} Area 124 {Area 124} Area 125 {Area 125} Area 126 {Area 126} Area 127 {Area 127} Area 130 {Area 130} Area 142 {Area 142}}
                </span>
              </h6>
                            @if (catchReport.subAreas.length) {
                              <h6 i18n class="field-label"
                                >
                <span style="display:inline; font-weight:700;">
                  Subareas or Zones:
                </span>
                @for (subarea of catchReport.subAreas; track subarea; let index = $index) {
<span style="display:inline"
                     >
                  @if (index < (catchReport.subAreas.length - 1)) {
<span>
                    {{subarea}},
                  </span>
}
                  @if (index === (catchReport.subAreas.length - 1)) {
<span>
                    {{subarea}}
                  </span>
}
                </span>
}
              </h6>
                            }
                            @if (trip.logbook.gearName==='Gill Net') {
                              <h6 i18n class="field-label"
                                >
                <span style="display:inline; font-weight:700;">
                  Net Used:
                </span>
                <span style="display:inline">
                  {{catchReport.netUsed}}
                </span>
              </h6>
                            }
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Hours Fished:
                </span>
                <span style="display:inline">
                  {{catchReport.hoursFished}}
                </span>
              </h6>
                            @if (trip.logbook.gearName!='Troll') {
                              <h6 i18n class="field-label"
                                >
                <span style="display:inline; font-weight:700;">
                  Number of Sets:
                </span>
                <span style="display:inline">
                  {{catchReport.numSets}}
                </span>
              </h6>
                            }
                            @if (trip.logbook.gearName==='Troll') {
                              <h6 i18n class="field-label"
                                >
                <span style="display:inline; font-weight:700;">
                  Storage Type:
                </span>
                <span style="display:inline">
                  {{catchReport.storageType}}
                </span>
              </h6>
                            }
                            @if (!!catchReport.comments) {
                              <h6 i18n class="field-label"
                                >
                <span style="display:inline; font-weight:700;">
                  Comments:
                </span>
                <span style="display:inline">
                  {{catchReport.comments}}
                </span>
              </h6>
                            }
                            <div class="row" style="padding-top: 15px;"></div>
                            <!-- Catch Table -->
                            @if (catchReport.speciesDataList.length) {
                              <table mat-table
                                [dataSource]="catchReport.speciesDataList"
                                class="mat-elevation-z0 margin-table">
                                <!-- Name Column -->
                                <ng-container matColumnDef="speciesName">
                                  <tr>
                                    <th i18n mat-header-cell
                                      *matHeaderCellDef
                                      class="heading-cell">
                      Species
                    </th>
                                    <td mat-cell
                                      *matCellDef="let element"
                                      class="data-cell">
                                      {{element.speciesName}}
                                    </td>
                                  </tr>
                                </ng-container>
                                <!-- Kept Column -->
                                <ng-container matColumnDef="kept">
                                  <tr>
                                    <th i18n mat-header-cell
                                      *matHeaderCellDef
                                      class="heading-cell">
                      Kept
                    </th>
                                    <td mat-cell
                                      *matCellDef="let element"
                                      class="data-cell">
                                      {{element.kept}}
                                    </td>
                                  </tr>
                                </ng-container>
                                <!-- Released Column -->
                                <ng-container matColumnDef="released">
                                  <tr>
                                    <th i18n mat-header-cell
                                      *matHeaderCellDef
                                      class="heading-cell">
                      Released
                    </th>
                                    <td mat-cell
                                      *matCellDef="let element"
                                      class="data-cell">
                                      {{element.released}}
                                    </td>
                                  </tr>
                                </ng-container>
                                <!-- Rows -->
                                <tr mat-header-row
                                  *matHeaderRowDef="catchService.catchColumns">
                                </tr>
                                <tr mat-row
                                  *matRowDef="let row; columns: catchService.catchColumns; let index=index;">
                                </tr>
                              </table>
                            }
                            @if (!catchReport.speciesDataList.length) {
                              <h6 i18n class="field-label"
                                >
                <span style="display:inline; font-weight:700;">
                  No Catch Reported.
                </span>
              </h6>
                            }
                          </mat-expansion-panel>
                        </div>
                      }
                    </mat-expansion-panel>
                  }
                </div>
                <!-- Offload Catch Reports -->
                <div class="sub-trips">
                  @if (trip.offloadReports.length) {
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title i18n class="panel-title">
              @if (containsUnsubmittedReports(trip.offloadReports)) {
<mat-icon>
                priority_high
              </mat-icon>
}
              Offload Reports &nbsp;
              <span class="panel-date" style="font-weight: 500">
                (count: {{trip.offloadReports.length}})
              </span>
            </mat-panel-title>
                      </mat-expansion-panel-header>
                      @for (offloadReport of trip.offloadReports; track offloadReport) {
                        <div class="sub-trips"
                          >
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>
                              <mat-panel-title class="panel-title">
                                @if (!offloadReport.isSubmitted) {
                                  <mat-icon>
                                    priority_high
                                  </mat-icon>
                                }
                                <span class="panel-date">
                                  {{sharedMethodsService.getDate(offloadReport.offloadDate) | date: 'dd/MM/yyyy'}}
                                </span>
                              </mat-panel-title>
                              @if (offloadReport.confirmationNumber.startsWith('FOS')) {
                                <button
                                  mat-button
                                  color="primary"
                                  (click)="onEditReport(trip, 'offload', offloadReport.internalId)">
                                  Edit
                                </button>
                              }
                            </mat-expansion-panel-header>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Date Completed:
                </span>
                <span style="display:inline">
                  {{sharedMethodsService.getDate(offloadReport.completionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
                </span>
              </h6>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Date Submitted:
                </span>
                @if (offloadReport.isSubmitted) {
<span style="display:inline"
                     >
                  {{sharedMethodsService.getDate(offloadReport.completionDate) | date: 'dd/MM/yyyy HH:mm:ss'}}
                </span>
}
                @if (!offloadReport.isSubmitted) {
<span style="display:inline"
                     
                      class="not-submitted">
                  Not Sent To DFO
                </span>
}
              </h6>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Confirmation Number:
                </span>
                <span style="display:inline">
                  {{offloadReport.confirmationNumber}}
                </span>
              </h6>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Report ID:
                </span>
                <span style="display:inline">
                  {{offloadReport.reportID}}
                </span>
              </h6>
                            <div class="row" style="padding-top: 15px;"></div>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Offload Time:
                </span>
                <span style="display:inline">
                  {{sharedMethodsService.getDate(offloadReport.offloadDate) | date: "shortTime"}}
                </span>
              </h6>
                            <h6 class="field-label">
                              <span i18n style="display:inline; font-weight:700;">
                  Landing Site:
                </span>
                              @if (offloadReport.landingSite.name == 'Not Listed' || offloadReport.landingSite.name == 'Not Offloading / No Catch') {
                                <span>
                                  {offloadReport.landingSite, select, Not Listed {Not Listed} Not Offloading / No Catch {Not Offloading / No Catch}}
                                </span>
                              }
                              @if (offloadReport.landingSite.name != 'Not Listed' && offloadReport.landingSite.name != 'Not Offloading / No Catch') {
                                <span>
                                  {{offloadReport.landingSite}}
                                </span>
                              }
                            </h6>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Product Type:
                </span>
                <span style="display:inline">
                  {offloadReport.productType, select, Unknown {Unknown} Round, Fresh {Round, Fresh} Dressed, Head On, Fresh {Dressed, Head On, Fresh} Dressed, Head Off, Fresh {Dressed, Head Off, Fresh} Round, Frozen {Round, Frozen} Dressed, Head On, Frozen {Dressed, Head On, Frozen} Dressed, Head Off, Frozen {Dressed, Head Off, Frozen} Roe, Fresh {Roe, Fresh} Round, Unknown Preservation {Round, Unknown Preservation}}
                </span>
              </h6>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Last Management Area Fished:
                </span>
                <span style="display:inline">
                  {offloadReport.lastMgmtArea, select, Area 1 {Area 1} Area 2 {Area 2} Area 3 {Area 3} Area 4 {Area 4} Area 5 {Area 5} Area 6 {Area 6} Area 7 {Area 7} Area 8 {Area 8} Area 9 {Area 9} Area 10 {Area 10} Area 11 {Area 11} Area 12 {Area 12} Area 13 {Area 13} Area 14 {Area 14} Area 15 {Area 15} Area 16 {Area 16} Area 17 {Area 17} Area 18 {Area 18} Area 19 {Area 19} Area 20 {Area 20} Area 21 {Area 21} Area 22 {Area 22} Area 23 {Area 23} Area 24 {Area 24} Area 25 {Area 25} Area 26 {Area 26} Area 27 {Area 27} Area 28 {Area 28} Area 29 {Area 29} Area 101 {Area 101} Area 102 {Area 102} Area 103 {Area 103} Area 104 {Area 104} Area 105 {Area 105} Area 106 {Area 106} Area 107 {Area 107} Area 108 {Area 108} Area 109 {Area 109} Area 110 {Area 110} Area 111 {Area 111} Area 121 {Area 121} Area 123 {Area 123} Area 124 {Area 124} Area 125 {Area 125} Area 126 {Area 126} Area 127 {Area 127} Area 130 {Area 130} Area 142 {Area 142}}
                </span>
              </h6>
                            @if (offloadReport.lastSubarea.isValid()) {
                              <h6 i18n class="field-label"
                                >
                <span style="display:inline; font-weight:700;">
                  Last Subarea Fished:
                </span>
                <span style="display:inline">
                  {{offloadReport.lastSubarea}}
                </span>
              </h6>
                            }
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Number of Days Fished:
                </span>
                <span style="display:inline">
                  {{offloadReport.numDaysFished}}
                </span>
              </h6>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  First and Last Days Fished:
                </span>
                <span style="display:inline">
                  {{offloadReport.firstDateFished |  date: 'dd/MM/yyyy'}} -  {{offloadReport.lastDateFished |  date: 'dd/MM/yyyy'}}
                </span>
              </h6>
                            <h6 i18n class="field-label">
                <span style="display:inline; font-weight:700;">
                  Fish Slip Issued:
                </span>
                <span style="display:inline">
                  {offloadReport.fishSlip, select, Yes {Yes} No {No}}
                </span>
              </h6>
                            @if (offloadReport.fishSlip==='Yes') {
                              <h6 i18n class="field-label"
                                >
                <span style="display:inline; font-weight:700;">
                  Fish Slip Number:
                </span>
                <span style="display:inline">
                  {{offloadReport.fishSlipNumber}}
                </span>
              </h6>
                            }
                            @if (offloadReport.comments.length) {
                              <h6 i18n class="field-label"
                                >
                <span style="display:inline; font-weight:700;">
                  Comments:
                </span>
                <span style="display:inline">
                  {{offloadReport.comments}}
                </span>
              </h6>
                            }
                            <div class="row" style="padding-top: 15px;"></div>
                            <!-- Offload Catch Table -->
                            @if (offloadReport.speciesDataList.length) {
                              <table mat-table
                                [dataSource]="offloadReport.speciesDataList"
                                class="mat-elevation-z0 margin-table">
                                <!-- Name Column -->
                                <ng-container matColumnDef="speciesName">
                                  <tr>
                                    <th i18n mat-header-cell
                                      *matHeaderCellDef
                                      class="heading-cell">
                      Species
                    </th>
                                    <td mat-cell class="data-cell"
                                      *matCellDef="let element">
                                      {{element.speciesName}}
                                    </td>
                                  </tr>
                                </ng-container>
                                <!-- Weight Column (Seine only) -->
                                @if (trip.logbook.gearName === 'Seine') {
                                  <ng-container
                                    matColumnDef="weight">
                                    <tr>
                                      <th i18n mat-header-cell
                                        *matHeaderCellDef
                                        class="heading-cell">
                      Weight <small>({{offloadReport.catchWeightUnits}})</small>
                    </th>
                                      <td mat-cell class="data-cell"
                                        *matCellDef="let element">
                                        {{element.offloadWeight}}
                                      </td>
                                    </tr>
                                  </ng-container>
                                }
                                <!-- Pieces Column -->
                                <ng-container matColumnDef="pieces">
                                  <tr>
                                    <th i18n mat-header-cell
                                      *matHeaderCellDef
                                      class="heading-cell">
                      Pieces
                    </th>
                                    <td mat-cell class="data-cell"
                                      *matCellDef="let element">
                                      {{element.offloadPieces}}
                                    </td>
                                  </tr>
                                </ng-container>
                                <!-- Rows -->
                                <tr mat-header-row
                                  *matHeaderRowDef="determineOffloadColumns(trip.logbook.gearName)">
                                </tr>
                                <tr mat-row
                                  *matRowDef="let row; columns: determineOffloadColumns(trip.logbook.gearName); let index=index;">
                                </tr>
                              </table>
                            }
                            @if (!offloadReport.speciesDataList.length) {
                              <h6 i18n class="field-label"
                                >
                <span style="display:inline; font-weight:700;">
                  No Catch Reported.
                </span>
              </h6>
                            }
                          </mat-expansion-panel>
                        </div>
                      }
                    </mat-expansion-panel>
                  }
                </div>
              </mat-expansion-panel>
            }
          </div>
        }
        <div class="row" style="padding-top: 20px;"></div>
      </div>
    }
